import type { ReactNode } from 'react';
import { SearchX } from 'lucide-react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: ReactNode;
  };
}

export function EmptyState({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16 tw-px-4">
      <div className="tw-mb-4 tw-text-gray-300">
        {icon || <SearchX className="tw-w-12 tw-h-12" />}
      </div>
      <h3 className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-1">{title}</h3>
      {description && (
        <p className="tw-text-sm tw-text-gray-500 tw-text-center tw-max-w-sm tw-mb-0">{description}</p>
      )}
      {action && (
        <button
          onClick={action.onClick}
          className="tw-mt-4 tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-bg-affinicar-primary tw-rounded-lg hover:tw-bg-affinicar-dark tw-transition-colors"
        >
          {action.icon}
          {action.label}
        </button>
      )}
    </div>
  );
}
